import { Link } from '@tanstack/react-router';
import { NamespaceBoundary } from '@/lib/i18n/NamespaceBoundary';
import { useTranslation } from '@/lib/i18n/react';

/** Missing URLs use personal product copy, including before login. */
export function RouteNotFound() {
  return <NamespaceBoundary namespace="shell"><NotFoundContent /></NamespaceBoundary>;
}

function NotFoundContent() {
  const { t } = useTranslation('shell');
  const { t: common } = useTranslation();
  return (
    <main className="flex min-h-screen items-center justify-center bg-paper p-6 text-fg-1">
      <section className="w-full max-w-lg rounded-md border border-border-subtle bg-white p-6">
        <h1 className="font-display text-xl font-bold">{t('notFound')}</h1>
        <Link to="/" className="mt-5 inline-flex min-h-11 items-center text-sm font-semibold text-blaze-violet underline">{common('routeError.home')}</Link>
      </section>
    </main>
  );
}
